module.exports = __webpack_public_path__ + "static/media/kai.abcbcbba.jpg";